import React, { useMemo, useState } from 'react'

const FILTERS = ['All', 'TypeScript', 'JavaScript', 'Python', 'Rust', 'Other']

const formatSize = (kilobytes) => {
  if (kilobytes < 1024) return `${kilobytes} KB`
  return `${(kilobytes / 1024).toFixed(1)} MB`
}

const ProjectShowcase = ({ repos, status }) => {
  const [filter, setFilter] = useState('All')

  const filteredRepos = useMemo(() => {
    const sorted = [...repos].sort((a, b) => {
      if (b.stargazers_count !== a.stargazers_count) return b.stargazers_count - a.stargazers_count
      return new Date(b.updated_at) - new Date(a.updated_at)
    })

    if (filter === 'All') return sorted
    if (filter === 'Other') {
      return sorted.filter((repo) => !FILTERS.slice(1, -1).includes(repo.language))
    }
    return sorted.filter((repo) => repo.language === filter)
  }, [repos, filter])

  if (status === 'loading') {
    return <div className="repo-status">Loading live repository data…</div>
  }

  if (status === 'error') {
    return (
      <div className="repo-status repo-status--error">
        GitHub did not return repository data. Nothing fabricated is being shown in its place.
      </div>
    )
  }

  return (
    <div className="project-showcase">
      <div className="filter-rail" aria-label="Filter repositories by language">
        {FILTERS.map((item) => (
          <button
            key={item}
            type="button"
            className={filter === item ? 'active' : ''}
            onClick={() => setFilter(item)}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="project-grid">
        {filteredRepos.map((repo, index) => (
          <article className="project-card" key={repo.id} style={{ '--index': index }}>
            <div className="project-index">{String(index + 1).padStart(2, '0')}</div>
            <div className="project-card__body">
              <div className="project-topline">
                <span>{repo.language || 'Mixed'}</span>
                <span>{formatSize(repo.size)}</span>
              </div>
              <h3><a href={repo.html_url} target="_blank" rel="noreferrer">{repo.name}</a></h3>
              <p>{repo.description || 'No repository description provided on GitHub.'}</p>
              <div className="project-meta">
                <span>★ {repo.stargazers_count}</span>
                <span>⑂ {repo.forks_count}</span>
                <span>Updated {new Date(repo.updated_at).toLocaleDateString()}</span>
              </div>
              {repo.topics?.length > 0 && (
                <div className="topic-row">
                  {repo.topics.slice(0, 4).map((topic) => <span key={topic}>{topic}</span>)}
                </div>
              )}
            </div>
            <a className="project-arrow" href={repo.html_url} target="_blank" rel="noreferrer" aria-label={`Open ${repo.name} on GitHub`}>↗</a>
          </article>
        ))}
      </div>
    </div>
  )
}

export default ProjectShowcase
